// src/components/FAQ.jsx
import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "When will AERZEN AIR™ be delivered?",
    a: "Deliveries will start from 01 May 2026 onwards. Pre-booking customers receive priority manufacturing and dispatch."
  },
  {
    q: "Why should I pre-book instead of waiting?",
    a: "Pre-booking secures early production allocation, priority delivery, and founder-level pricing. The pre-booking amount is fully adjustable against the final invoice."
  },
  {
    q: "Is AERZEN AIR™ safe for infants and elderly?",
    a: "AERZEN AIR™ is designed for Indian homes with children, elders, and pets in mind, focusing on removing PM2.5, dust, smoke, and allergens."
  },
  {
    q: "Does an air purifier really make a difference indoors?",
    a: "During high pollution days, indoor air can become nearly as polluted as outdoors. A purifier helps reduce PM2.5 inside closed rooms."
  },
  {
    q: "What is CADR and why does it matter?",
    a: "CADR shows how quickly an air purifier cleans air. Higher CADR is crucial for faster and effective purification."
  },
  {
    q: "How noisy are AERZEN AIR™ purifiers?",
    a: "They are engineered for low-noise operation, suitable for bedrooms and night use."
  },
  {
    q: "Do you offer warranty?",
    a: "Yes, a 2-year comprehensive warranty is offered on selected models."
  },
  {
    q: "Are filters expensive?",
    a: "Filters will be easily available. Founder customers get 1 HEPA filter free during the first replacement cycle."
  },
  {
    q: "Is this built for Indian pollution?",
    a: "Yes. AERZEN AIR™ is engineered specifically for Indian smog, dust, Diwali smoke, and PM2.5 spikes."
  },
  {
    q: "What if I change my mind after pre-booking?",
    a: "The pre-booking amount is fully adjustable against the final invoice."
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);

  const questions = [
    {
      q: "Do you think an air purifier is necessary for your home today?",
      options: ["Yes, absolutely", "Maybe", "Not sure", "No"]
    },
    {
      q: "How often does outdoor pollution affect your home?",
      options: ["Almost daily", "During winters/Diwali", "Occasionally", "Rarely"]
    },
    {
      q: "Who are you most concerned about at home?",
      options: ["Children", "Elderly / Asthma", "Pets", "Everyone"]
    },
    {
      q: "Would preventing pollution-related illness be worth ₹25–₹40 per day?",
      options: ["Yes, definitely", "Probably", "Not sure", "No"]
    },
    {
      q: "Did you know indoor air can stay polluted even with windows closed?",
      options: ["Yes", "I suspected", "Didn’t know", "Surprising"]
    }
  ];

  const handleAnswer = (opt) => {
    setAnswers([...answers, opt]);
    setStep(step + 1);
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <h4 className="font-semibold mb-4">Frequently Asked Questions</h4>

      {/* FAQ LIST */}
      <div className="space-y-3">
        {faqs.map((f, i) => (
          <div key={i} className="border rounded-lg overflow-hidden">
            <button
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              className="w-full flex items-center justify-between p-4 text-left"
            >
              <div className="font-medium">{f.q}</div>
              <ChevronDown
                className={`h-5 w-5 transition-transform ${
                  openIndex === i ? "rotate-180" : ""
                }`}
              />
            </button>
            {openIndex === i && (
              <div className="p-4 pt-0 text-sm text-[var(--aerzen-black)]/70">
                {f.a}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* ---------------- POLL ---------------- */}
      <div className="mt-10 border-t pt-8">
        <h4 className="font-semibold text-lg mb-2">
          Quick Home Air Reality Check
        </h4>

        {step < questions.length ? (
          <>
            <p className="text-sm text-[var(--aerzen-black)]/70 mb-4">
              {questions[step].q}
            </p>
            <div className="grid sm:grid-cols-2 gap-3">
              {questions[step].options.map((opt) => (
                <button
                  key={opt}
                  onClick={() => handleAnswer(opt)}
                  className="border rounded-lg px-4 py-3 text-sm hover:border-[var(--aerzen-blue)] hover:bg-[var(--aerzen-blue)]/5 transition"
                >
                  {opt}
                </button>
              ))}
            </div>
          </>
        ) : (
          <div className="bg-[var(--aerzen-blue)]/5 rounded-xl p-5">
            <p className="font-medium mb-2">
              Your insight matters.
            </p>
            <p className="text-sm text-[var(--aerzen-black)]/70 leading-relaxed">
              Most Indian homes now experience unsafe indoor air for
              <strong> 120–180 days a year</strong>.  
              Families typically choose value-focused purifiers like
              <strong> Zen-S or Zen-M</strong> for everyday protection without overspending.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
